module.exports = __webpack_public_path__ + "static/Eat Bitter-5-a08d1cfb21652f61bd471e07a23f3160.jpg";